import Swal from "sweetalert2";
import { GetKey } from "../../../Helpers/GetKey";

const titulo = "Clientes";
const error = "error";
export const ValidaDomicilio = (state) => {
  if (state === undefined || state === null) {
    Swal.fire(
      "Clientes",
      "Error interno, favor de comunicarse con el administrador del sistema",
      "error"
    );
    return false;
  }
  if (
    state.codigo_postal === undefined ||
    state.codigo_postal === null ||
    state.codigo_postal === ""
  ) {
    Swal.fire(titulo, "El campo código postal es obligatorio", error);
    return false;
  }
  if (state.codigo_postal.length !== 5) {
    Swal.fire(titulo, "El campo código postal es invalido", error);
    return false;
  }

  if (
    state.localidad === undefined ||
    state.localidad === null ||
    state.localidad === ""
  ) {
    Swal.fire(titulo, "El campo localidad es obligatorio", error);
    return false;
  }
  if (
    state.tipodomicilio === undefined ||
    state.tipodomicilio === null ||
    state.tipodomicilio === ""
  ) {
    Swal.fire(titulo, "El campo tipo de domicilio es obligatorio", error);
    return false;
  }
  if (
    state.direccion === undefined ||
    state.direccion === null ||
    state.direccion === ""
  ) {
    Swal.fire(titulo, "El campo direccion es obligatorio", error);
    return false;
  }

  return {
    idcliente: "",
    orden: "",
    idlocalidad: Number(GetKey(state.localidad)),
    direccion: state.direccion,
    tipodomicilio: GetKey(state.tipodomicilio),
    principal: false,
    referencia1: state.referencia1,
    referencia2: state.referencia2,
    estatus: true,
  };
};
